module.exports = __webpack_public_path__ + "static/media/news__features.fdab788d.jpg";